/**
 * SAYM Instagram section: Reels play muted while their tile is on screen.
 *
 * The videos are rendered with preload="none", so nothing is downloaded until a
 * tile scrolls into view. They pause again off screen and in a background tab.
 * Visitors who prefer reduced motion keep the still image.
 */

const stillness = window.matchMedia('(prefers-reduced-motion: reduce)');

/** @param {HTMLVideoElement} video */
function play(video) {
  if (stillness.matches) return;
  video.play().then(
    () => video.setAttribute('data-playing', ''),
    // Autoplay refused (data saver, low power): the image simply stays
    () => {}
  );
}

/** @param {HTMLVideoElement} video */
function pause(video) {
  video.pause();
}

const videos = /** @type {HTMLVideoElement[]} */ ([...document.querySelectorAll('.saym-ig__video')]);

if (videos.length && 'IntersectionObserver' in window) {
  const visible = new Set();

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        const video = /** @type {HTMLVideoElement} */ (entry.target);
        if (entry.isIntersecting) {
          visible.add(video);
          if (!document.hidden) play(video);
        } else {
          visible.delete(video);
          pause(video);
        }
      }
    },
    { threshold: 0.5 }
  );

  videos.forEach((video) => observer.observe(video));

  document.addEventListener('visibilitychange', () => {
    visible.forEach((video) => (document.hidden ? pause(video) : play(video)));
  });

  stillness.addEventListener('change', () => {
    visible.forEach((video) => {
      if (stillness.matches) {
        pause(video);
        video.removeAttribute('data-playing');
      } else {
        play(video);
      }
    });
  });
}
